// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5Itmd-","image":"iGsFQW"};